import { render, staticRenderFns } from "./cardTemplateVip19.vue?vue&type=template&id=3bcfb92a&scoped=true&"
import script from "./cardTemplateVip19.vue?vue&type=script&lang=js&"
export * from "./cardTemplateVip19.vue?vue&type=script&lang=js&"
import style0 from "./cardTemplateVip19.vue?vue&type=style&index=0&id=3bcfb92a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bcfb92a",
  null
  
)

export default component.exports